module.exports = __webpack_public_path__ + "img/cave41.fdcefa02.jpg";